

const getTotalItems = (_total, _limit) => Math.ceil(_total / _limit)

const getBase64 = (file, cb) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        cb(reader.result, file.name, file.size)
    };
    reader.onerror = function (error) {
        console.log('Error: ', error);
    };
}

const PageHelper = {
    getTotalItems,
    getBase64
}


export default PageHelper